<script>
	import {Route, Router} from 'svelte-navigator';
	import Home from './components/Home.svelte';
	import Footer from './layout/Footer.svelte';
	import Header from './layout/Header.svelte';
</script>

<Router>
	<Header/>

	<main class="container">
		
	<Route path="/">
		<Home />
	</Route>
		<Route path="/projects">
		<div>
			<h1>Projects</h1>
		</div>
	</Route>
	<Route path="/about">
		<div>
			<h1>About</h1>
		</div>
	</Route>

	<Route path="/contact">
		<div>
			<h1>Contact</h1>
		</div>
	</Route>
	</main>
	<Footer/>

</Router>

<style>
	main{
		margin-top: 20px;
	}
</style>

